export default __webpack_public_path__ + "static/media/131.bfcc0a95.png";